const routes = [{
  path: '/myhome',
  component: () => import('@/views/main'),
  name: 'myhome',
  meta: {
    title: '首页'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/myhome/myhome.js